import { useSelection } from 'src/contexts/SelectionContext';
import { FeatureFlag, isFeatureEnabled } from 'src/featureFlags';

/**
 * React hook that evaluates a feature flag against the current marketplace
 * from SelectionContext.
 *
 * Use this inside any component that lives within the SelectionContext provider
 * tree (i.e. anywhere inside CampaignAutomationPage). It automatically picks
 * up the active marketplace so call sites don't have to pass it manually.
 *
 * For code that runs outside the React tree (configs, utility modules), use
 * `isFeatureEnabled(flag)` directly instead.
 *
 * @example
 * const isRdpEnabled = useFeatureFlag(FeatureFlag.RdpIntegration);
 * const isOverlayEnabled = useFeatureFlag(FeatureFlag.OverlaySection);
 */
export const useFeatureFlag = (flag: FeatureFlag): boolean => {
  const { marketplace } = useSelection();
  return isFeatureEnabled(flag, marketplace);
};
